import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { getLocalizedValue } from '@grandvisionhq/utils';
import { Description } from '../components/Description.js';

const DescriptionContainer = ({ description  })=>{
    const { locale  } = useIntl();
    const value = description && getLocalizedValue(description, locale);
    if (!value) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(Description, {
        value: value
    });
};

export { DescriptionContainer };
//# sourceMappingURL=DescriptionContainer.js.map
